<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="bg-white rounded-lg shadow-lg  w-[1000px] pb-[20px]">
            <!-- Header -->
            <div class="bg-primary rounded-t-lg px-6 py-3 flex justify-between items-center h-[48px]">
                <span class="text-white s !text-[14px]">ข้อมูลศูนย์พักพิง</span>
                <button @click="$emit('close')"
                    class="text-primary bg-white rounded-full text-2xl leading-none p-2 hover:text-gray-200">
                    <XmarkIcon class="w-2.5 h-2.5 text-primary" color="#9B237B" />
                </button>
            </div>
            <!-- Content -->
            <div class="px-[20px] pt-[12px] flex flex-col md:flex-row">
                <img :src="shelter.image" alt="shelter" class="w-full md:w-40 h-32 object-cover rounded" />
                <div class="grid gap-[16px] pl-[30px]">
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">ชื่อศูนย์พักพิง</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.name }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">เบอร์โทรศูนย์</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.phone }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">สถานะ</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.status }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">ก่อตั้งเมื่อ</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.founded }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">ผู้บัญชาการ/ผู้อำนวยการ</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.leader }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">จำนวนผ้ดูแล</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.units }}</div>
                    </div>
                    <div class="grid gap-[2px]">
                        <div class="PC_Body2-R text-[#7C7379]">จำนวนผู้ประสบภัย/ความจุ</div>
                        <div class="PC_Body2-R text-primary-dark !text-[16px]">{{ shelter.occupancy }}</div>
                    </div>

                     <div class="flex items-center gap-[10px]">
                     <!-- {{ shelter }} -->
                        <ButtonComponent
                        :bClass="'btn_shadow--gis'"
                        :label="'GIS Map'"
                        :href="shelter.gis_map"
                                      :target="'_blank'"
                        :disabled="shelter.gis_map == null"
                         />
                        <ButtonComponent
                        :bClass="'btn_shadow--gis'"
                        :label="'Google Map'"
                        :href="shelter.google_maps"
                                      :target="'_blank'"
                        :disabled="shelter.google_maps == null"
                        />
                    </div>
                    <!-- <div>
                        <button class="border border-[#B7B2B5] w-[83px] h-[50px] rounded-[6px]" @click="commandGIS()">GIS Map</button>
                    </div> -->

                </div>
            </div>
            <div v-if="manage && $route.path !== '/home-page'" class="flex gap-[10px] place-self-end pr-[20px] mt-[16px]">
                <button type="button" class="border border-[#B7B2B5] rounded-[6px] h-[50px] w-[84px] M text-primary-dark"
                    @click="$emit('close')">ย้อนกลับ</button>
                <button v-if="auth.hasRole([ROLES.admin])" type="button" class="border border-[#B7B2B5] rounded-[6px] h-[50px] w-[84px] M text-white bg-[#9B237B]"
                    @click="goShelterDetail(shelter)">เข้าสู่ศูนย์</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { boolean } from '@vueform/vueform';
import { useRouter } from "vue-router";
import { useShelterStore } from "@/pinia/shelter";
import { useAuthStore } from "@/pinia/authStore";
// import { storeToRefs } from "pinia";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const router = useRouter();
const shelterStore = useShelterStore();
const auth = useAuthStore();

defineProps({
    shelter: {
        type: Object,
        required: true,
        // default: () => ({
        //     image: '',
        //     name: '',
        //     phone: '',
        //     status: '',
        //     founded: '',
        //     leader: '',
        //     units: '',
        //     occupancy: ''
        // })
    },
    manage: {
        type: Boolean,
        required: false,
        default: false,
    }
})

const goShelterDetail = (data) => {
  localStorage.setItem("shelterID", JSON.stringify(data));
  router.push(`/shelter/${data.name}`);
};

function commandGIS(){
  window.open("https://shingeometics.com/webgis/ZWebMapCRI/", "_blank");
}

</script>